<template>
  <BaseItem
    v-if="insuranceOffer"
    :description="insuranceOffer.title"
    image="IconQuality"
    :label="i18n(translations.insurance)"
  />
</template>

<script setup lang="ts">
import type { InsuranceOffer } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import BaseItem from '../BaseItem/BaseItem.vue'

import translations from './Insurance.translations'

const i18n = useI18n()

defineProps<{
  insuranceOffer: InsuranceOffer | null
}>()
</script>
